/**
 * @fileoverview Application-wide configuration constants including branding
 * and API endpoint configuration.
 */

import { env } from './env';

// ============================================================================
// Branding Configuration
// ============================================================================

/**
 * Application branding configuration interface.
 */
export interface AppBranding {
  /** Application title displayed in header and browser tab. */
  readonly title: string;
}

/**
 * Application branding configuration.
 */
export const BRANDING: AppBranding = {
  title: '',
} as const;

// ============================================================================
// API Configuration
// ============================================================================

/**
 * Infers the default API base URL based on the current hostname.
 * Returns localhost API URL for local development, otherwise uses the
 * current origin with /api path.
 */
function inferDefaultApiBaseUrl(): string {
  const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  if (isLocalhost) {
    return 'http://localhost:3002/api';
  }
  return `${window.location.origin}/api`;
}

/**
 * Base URL for all API requests. Uses environment variable if set,
 * otherwise infers from current hostname.
 */
export const API_BASE_URL: string = env.VITE_API_BASE_URL || inferDefaultApiBaseUrl();
